module.exports = __webpack_public_path__ + "static/img/OM11.87e110d0.png";